/**
 * @file `GlossaryContext` — the course glossary shared by `<Term/>`
 *       tooltips and the full `<Glossary/>` render.
 * @module @labcraft/course-kit/components/glossary_context
 *
 * Lives in its own module so both `term.tsx` (which provides it via
 * `<GlossaryProvider/>` and reads it in `<Term/>`) and `glossary.tsx`
 * (which falls back to it when `<Glossary/>` renders without an explicit
 * `terms` prop) can import it without a circular dependency — `term.tsx`
 * already imports `renderInline` from `glossary.tsx`.
 */

import { createContext } from 'react'
import type { Term } from '../types.ts'

/**
 * Course glossary, populated by `<GlossaryProvider terms={course.glossary}>`
 * around each chapter. Defaults to `[]` so a component read outside a provider
 * degrades to an empty render rather than throwing.
 */
export const GlossaryContext = createContext<readonly Term[]>([])
